/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShoppingCartDown = createReactComponent(
  "shopping-cart-down",
  "IconShoppingCartDown",
  [
    ["path", { d: "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
    ["path", { d: "M12.5 17h-6.5v-14h-2", key: "svg-1" }],
    ["path", { d: "M6 5l14 1l-.859 6.011m-2.641 .989h-10.5", key: "svg-2" }],
    ["path", { d: "M19 16v6", key: "svg-3" }],
    ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-4" }]
  ]
);

export { IconShoppingCartDown as default };
//# sourceMappingURL=IconShoppingCartDown.js.map
